import React from "react";

import CoverageSecondaryKpis from "./CoverageSecondaryKpis";
import CoverageAdequacyTable from "./CoverageAdequacyTable";
import FinancialPositionSummary from "./FinancialPositionSummary";
import CoverageExecutiveInsight from "./CoverageExecutiveInsight";

export default function CoverageAdequacyPanel({
  data,
  settings,
  loading,
  error,
  onRefresh,
  onAnalyzeScenario,
}) {
  if (loading && !data) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-6 text-sm text-slate-500">
        Calculating coverage adequacy...
      </div>
    );
  }

  if (error && !data) {
    return (
      <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-sm text-red-800">
        Unable to calculate coverage adequacy.
      </div>
    );
  }

  const summary =
    data?.summary || {};

  const scenarios =
    Array.isArray(data?.scenarios)
      ? data.scenarios
      : [];

  return (
    <section className="space-y-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-lg font-semibold text-slate-900">
            Digital Risk Financial Position
          </h2>

          <p className="mt-1 text-sm text-slate-500">
            Compare quantified P95 exposure with current
            nominal transfer capacity.
          </p>

          <p className="mt-1 text-xs text-slate-400">
            This initial measure excludes policy exclusions,
            aggregate-limit consumption and coverage overlap.
          </p>
        </div>

        <button
          type="button"
          onClick={onRefresh}
          disabled={loading}
          className="rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 disabled:opacity-50"
        >
          {loading
            ? "Refreshing..."
            : "Refresh"}
        </button>
      </div>

      {error && data && (
        <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
          The latest refresh failed. Previous results remain displayed.
        </div>
      )}

      <FinancialPositionSummary
        summary={summary}
        settings={settings}
      />

      <CoverageExecutiveInsight
        summary={summary}
        settings={settings}
      />

      <CoverageSecondaryKpis
        summary={summary}
        settings={settings}
      />

      <div className="pt-2">
        <h3 className="text-base font-semibold text-slate-900">
          Scenario Financial Protection
        </h3>

        <p className="mt-1 text-sm text-slate-500">
          Financial protection and remaining capital at risk by FAIR scenario.
        </p>
      </div>

      <CoverageAdequacyTable
        scenarios={scenarios}
        settings={settings}
        onAnalyzeScenario={
          onAnalyzeScenario
        }
      />
    </section>
  );
}